import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import BasicAccountApplicationOpenItem from "../../../../ui/widgets/basic-account-application-item/open";
import ProductImage from "../../../shared/components/product-image";
import { OpenProductProps } from "./types";
import FloatingActionButton from "../../../../ui/widgets/floating-action-button";
import { ProductContext } from "../../../../context/product-context/productContext";

export default function OpenProduct({
  product,
  startApplication,
}: OpenProductProps): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const { setSelectedProduct, findProduct } = useContext(ProductContext);

  const button = (
    <FloatingActionButton
      kind="add"
      text={getMessage("Dashboard.basicAccountApplicationOpen.button-text")}
      onClick={() => {
        setSelectedProduct(findProduct(product));
        startApplication(product);
      }}
    />
  );

  return (
    <BasicAccountApplicationOpenItem
      product={product}
      image={<ProductImage product={product} />}
      title={getMessage(`Product.${product}.title`)}
      button={button}
    />
  );
}
